import { getPrice } from '@fourthwall/utils/dist'
import React from 'react'
import { Accordion } from '../../../../../../common/Accordion'
import { AccordionHeading } from '../AccordionHeading'
import { AccordionPanel } from '../AccordionPanel'
import * as S from './styled'
import type { Props } from './types'

export const AccordionItem = ({
  autoAdjustedSellingPrice,
  data,
  expanded,
  isMinimumQuantity,
  includeFeesValue,
  onChange,
  ...props
}: Props) => {
  return (
    <Accordion.Item
      expanded={expanded}
      heading={
        <AccordionHeading
          isMinimumQuantity={isMinimumQuantity}
          profit={data.unitProfit}
          quantity={data.numberOfUnits}
          showProfit={!expanded}
        />
      }
      footer={
        <S.TotalProfitContainer>
          <S.TotalProfitCopy>
            {`${getPrice(data.totalProfit)} for ${data.numberOfUnits} sold`}
          </S.TotalProfitCopy>
        </S.TotalProfitContainer>
      }
      onChange={onChange}
      {...props}
    >
      <AccordionPanel
        cost={data.cost}
        price={data.price}
        profit={data.unitProfit}
        feesValue={data.feesValue}
        includeFeesValue={includeFeesValue}
        autoAdjustedSellingPrice={autoAdjustedSellingPrice}
      />
    </Accordion.Item>
  )
}
